import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';

import GroupReport from './GroupReport';

const GroupReportContainer = props => (
  <Provider store={store}>
    <GroupReport {...props} />
  </Provider>
);

export default GroupReportContainer;
